decodedChar